const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

/**
 * @param {string} targetId - ID of element to scroll to
 * @param {number} duration - Animation duration in ms
 * @param {number} offset - Offset in px (for fixed headers)
 * @param {string|null} containerId - ID of the wrapper div. If null, scrolls window.
 */
export const smoothScroll = (
  targetId,
  duration = 1000,
  offset = 0,
  containerId = null,
) => {
  const target = document.getElementById(targetId);
  if (!target) return;

  let container = window;
  let startPosition = window.scrollY;

  if (containerId) {
    const c = document.getElementById(containerId);
    if (c) {
      container = c;
      startPosition = c.scrollTop;
    }
  }

  let targetPosition = 0;

  if (container === window) {
    targetPosition = target.getBoundingClientRect().top + window.scrollY;
  } else {
    const targetTop = target.getBoundingClientRect().top;
    const containerTop = container.getBoundingClientRect().top;
    targetPosition = startPosition + (targetTop - containerTop);
  }

  const distance = targetPosition - startPosition - offset;
  let startTime = null;

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;

    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);

    if (container === window) {
      window.scrollTo(0, run);
    } else {
      container.scrollTop = run;
    }

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      const finalPos = targetPosition - offset;
      if (container === window) window.scrollTo(0, finalPos);
      else container.scrollTop = finalPos;
    }
  };

  requestAnimationFrame(animation);
};
